import { FC } from 'react';

import { ComplaintCard } from './children/ComplaintCard';
import { ContractCard } from './children/ContractCard';
import { ExtractCard } from './children/ExtractCard';
import { InsuranceOrderCard } from './children/InsuranceOrderCard';
import { PermitCard } from './children/PermitCard';
import { ReceiptCard } from './children/ReceiptCard';
import { UserRequestCard } from './children/UserRequestCard';
import { UserRequestDraftCard } from './children/UserRequestDraftCard';
import { UserRequestPartCard } from './children/UserRequestPartCard';
import { WeaponPartCard } from './children/WeaponPartCard';
import { WeaponRegisteredCard } from './children/WeaponRegisteredCard';
import { ServiceRowCardProps, ServiceRowCardVariant } from './model/types';

import './ServiceRowCard.scss';

export const ServiceRowCard: FC<ServiceRowCardProps> = (props) => {
  switch (props.variant) {
    case ServiceRowCardVariant.COMPLAINT:
      return <ComplaintCard {...props} />;

    case ServiceRowCardVariant.RECEIPT:
      return <ReceiptCard {...props} />;

    case ServiceRowCardVariant.EXTRACT:
      return <ExtractCard {...props} />;

    case ServiceRowCardVariant.CONTRACT:
      return <ContractCard {...props} />;

    case ServiceRowCardVariant.PERMIT:
      return <PermitCard {...props} />;

    case ServiceRowCardVariant.USER_REQUEST:
      return <UserRequestCard {...props} />;

    case ServiceRowCardVariant.USER_REQUEST_DRAFT:
      return <UserRequestDraftCard {...props} />;

    case ServiceRowCardVariant.USER_REQUEST_PART:
      return <UserRequestPartCard {...props} />;

    case ServiceRowCardVariant.WEAPON_REGISTERED:
      return <WeaponRegisteredCard {...props} />;

    case ServiceRowCardVariant.WEAPON_PART:
      return <WeaponPartCard {...props} />;

    case ServiceRowCardVariant.INSURANCE_ORDER:
      return <InsuranceOrderCard {...props} />;

    default:
      return null;
  }
};
